import React, { useState, useCallback, useEffect } from "react";
import {
  Select,
  Card,
  PageActions,
  Text,
  Loading,
  Button,
  Page,
  InlineError,
  FormLayout,
  Spinner,
  Toast,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import TranslationRow from "../../Components/TranslationRow";
import { accessUiText, adminRole } from "../../Helpers";
import SelectSearch from "react-select-search";
import "react-select-search/style.css";

const Translations = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const loadingMarkup = isLoading ? <Loading /> : null;
  const [ts, setTs] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [optionsLanguages, setOptionsLanguages] = useState("");
  const [selected, setSelected] = useState("en");
  const handleSelectChange = (value) => setSelected(value);
  const [data, setData] = useState([]);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const [optionsPages, setOptionsPages] = useState("");
  const [selectedPage, setSelectedPage] = useState("");
  const handleChangePage = (newValue) => {
    setSelectedPage(newValue);
    setData([]);
  };
  useEffect(() => {
    fetchData();
  }, [ts, selectedPage]);
  async function fetchData() {
    let responseLanguages = "";
    let responseTranslations = "";
    let responsePages = "";
    // if (optionsLanguages === "") {
    try {
      responseLanguages = await axios.get(
        `/settings/languages?filter[is_active]=1`
      );
      responseLanguages?.data?.data?.data &&
        setOptionsLanguages(
          responseLanguages.data.data.data

            .map((item, index) => {
              return {
                key: index,
                label: item.name,
                value: item.code,
              };
            })
            .concat([{ label: "English", value: "en" }])
        );
    } catch (error) {
      console.log(error);
    }
    //}
    if (optionsPages === "") {
      try {
        responsePages = await axios.get(`/pages?per_page=1000`);
        responsePages?.data?.data?.data &&
          setOptionsPages(
            responsePages.data.data.data.map((item, index) => {
              return {
                label: item.title.en,
                value: String(item.id),
                key: String(item.id),
              };
            })
          );
      } catch (error) {
        console.log(error);
      }
    }
    if (props.type === "ui" && selectedPage !== "") {
      try {
        responseTranslations = await axios.get(
          `/${props.url}?page_id=${selectedPage}`
        );
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        responseTranslations = await axios.get(`/${props.url}`);
      } catch (error) {
        console.log(error);
      }
    }

    if (responseTranslations.data.data.length) {
      let array = [];

      for (var i = 0; i < responseTranslations.data.data.length; i++) {
        const item = responseTranslations.data.data[i];
        const itemValues =
          props.type === "social" ? item.values : item.translations;
        for (var j = 0; j < Object.keys(itemValues).length; j++) {
          const itemChild = Object.keys(itemValues)[j];
          const object = {
            language: item.lang,
            handle: itemChild ? itemChild : "",
            text: itemValues[itemChild] ? itemValues[itemChild] : "",
          };
          array.push(object);
        }
      }
      const firstElementValues =
        props.type === "social"
          ? responseTranslations.data.data[0].values
          : responseTranslations.data.data[0].translations;

      for (var i = 0; i < responseLanguages.data.data.data.length; i++) {
        if (
          array.some(
            (e) => e.language === responseLanguages.data.data.data[i].code
          ) === false
        ) {
          for (var j = 0; j < Object.keys(firstElementValues).length; j++) {
            array.push({
              language: responseLanguages.data.data.data[i].code,
              handle: Object.keys(firstElementValues)[j]
                ? Object.keys(firstElementValues)[j]
                : "",
              text: "",
            });
          }
        }
      }
      setData(array);
    }

    setIsLoading(false);
  }
  const updateData = (param) => {
    setData(param);
    setErrorMessage("");
  };
  const handleAddItem = () => {
    if (data.some((e) => e.handle === "") === true) {
      setErrorMessage("There is an empty please fill it");
    } else {
      for (var i = 0; i < optionsLanguages.length; i++) {
        const object = {
          language: optionsLanguages[i].value,
          handle: "",
          text: "",
        };
        setData((data) => [...data, object]);
      }
    }
  };
  const options = [
    { name: "Swedish", value: "sv" },
    { name: "English", value: "en" },
    {
      type: "group",
      name: "Group name",
      items: [{ name: "Spanish", value: "es" }],
    },
  ];
  return (
    accessUiText() && (
      <Page
        title={props.title}
        primaryAction={
          <Button
            primary
            onClick={handleAddItem}
            disabled={adminRole() === "Editor"}
          >
            Add Item
          </Button>
        }
        narrowWidth
      >
        <Card sectioned>
          {/* <h1>{JSON.stringify(data)}</h1> */}

          {loadingMarkup}

          {isLoading ? (
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          ) : (
            <FormLayout>
              {/* <SelectSearch
              options={options}
              value="sv"
              name="language"
              placeholder="Choose your language"
            /> */}

              {props.type === "ui" && (
                <Select
                  label="Page"
                  options={optionsPages}
                  onChange={handleChangePage}
                  value={selectedPage}
                  placeholder="Please select"
                />
              )}
              {(props.type === "social" ||
                (props.type === "ui" && selectedPage !== "")) && (
                <div className="mt-3">
                  <Select
                    label="Language"
                    options={optionsLanguages}
                    onChange={handleSelectChange}
                    value={selected}
                    placeholder="Please select a language"
                  />
                  <div className="mt-3">
                    {data && data.length ? (
                      <table className="tableTranslations">
                        <tbody>
                          <tr>
                            <th>
                              <Text variant="bodyMd" as="p" fontWeight="medium">
                                {props.tableTitle1}
                              </Text>
                            </th>
                            <th>
                              <Text variant="bodyMd" as="p" fontWeight="medium">
                                {props.tableTitle2}
                              </Text>
                            </th>
                          </tr>

                          {data
                            .filter(({ language }) => language === selected)
                            .map((element, index) => {
                              return (
                                <TranslationRow
                                  key={index}
                                  object={JSON.stringify(element)}
                                  data={data}
                                  updateData={updateData}
                                  language={selected}
                                />
                              );
                            })}
                        </tbody>
                      </table>
                    ) : (
                      <Text variant="headingSm" as="h6">
                        No items found. Click on 'Add Item' button to add a new
                        value.
                      </Text>
                    )}
                  </div>
                </div>
              )}
            </FormLayout>
          )}

          {/* {data &&
          data
            .filter(({ language }) => language === selected)
            .map((element, index) => {
              return (
                <div key={index} style={{ marginTop: "0.5rem" }}>
                  <TranslationRow
                    object={JSON.stringify(element)}
                    data={data}
                    updateData={updateData}
                    language={selected}
                  />
                </div>
              );
            })} */}
          <InlineError message={errorMessage} />
        </Card>
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
      </Page>
    )
  );
  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    data.forEach(
      (selected, index) =>
        selected.handle &&
        form_data.append(
          `${selected.language}[${selected.handle}]`,
          selected.text
        )
    );
    props.type === "ui" &&
      selectedPage !== "" &&
      form_data.append("page_id", selectedPage);
    axios
      .post(`/${props.url}`, form_data)
      .then((res) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch((err) => console.log(""));
  }
};
export default Translations;
